/** Gränsen för att markera fortkörning på en tripp: 10 % över rådande hastighetsgräns. */
export const OVER_SPEED_FACTOR = 1.1;

export function isTenPercentOverLimit(
  speed: number | null | undefined,
  limit: number | null | undefined,
): boolean {
  if (speed == null || limit == null) return false;
  if (!Number.isFinite(speed) || !Number.isFinite(limit) || limit <= 0) return false;
  return speed > limit * OVER_SPEED_FACTOR;
}
